module.exports = __webpack_public_path__ + "img/logo-igi@2x.801405e.png";